export const PLANT_ORIGINS = {
  HUAWEI: 'HUAWEI',
  SUNGROW: 'SUNGROW',
}

export default {
  auto: '*',
}
